import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Envelope, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import ProntoLogo from "@/components/ProntoLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim() });
      setSubmitted(true);
      toast.success("Link inviato. Controlla la tua casella email (anche la cartella Spam).");
    } catch (err) {
      // iter v30 r090 — Mostra esplicitamente l'errore: il vecchio codice
      // mangiava silenziosamente le eccezioni e l'utente non capiva se la
      // richiesta era stata inviata o no.
      toast.error(apiError(err, "Errore di rete. Riprova fra qualche secondo."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-block mb-10" data-testid="back-home-logo">
          <img src="/logo/mark-symbol.png?v=8" alt="Pronto" className="h-12 w-12 select-none" draggable="false" />
        </Link>
        {!submitted ? (
          <>
            <h1 className="font-editorial text-4xl tracking-tight text-[#1C1C1A]" data-testid="forgot-password-title">
              Password<br/>
              <span className="italic-accent text-[#7C8B6E]">dimenticata?</span>
            </h1>
            <p className="mt-4 text-[#6B6A65]">
              Inserisci la tua email. Ti mandiamo un link per reimpostare la password.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-password-form">
              <label className="block">
                <span className="text-xs uppercase tracking-[0.18em] text-[#6B6A65]">Email</span>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-[#E5E7E0] focus:border-[#7C8B6E] outline-none transition-colors"
                  placeholder="mario.rossi@agenzia.it"
                  data-testid="forgot-password-email"
                />
              </label>
              <button
                type="submit"
                disabled={loading || !email.trim()}
                className="btn-primary w-full justify-center"
                data-testid="forgot-password-submit"
              >
                {loading ? "Invio in corso..." : <>Invia link <ArrowRight size={18} weight="bold" /></>}
              </button>
            </form>
            <p className="mt-8 text-sm text-center text-[#6B6A65]">
              Ti ricordi la password? <Link to="/login" className="text-[#7C8B6E] underline" data-testid="back-to-login">Accedi</Link>
            </p>
          </>
        ) : (
          <div data-testid="forgot-password-sent">
            <div className="w-16 h-16 rounded-full bg-[#F1F4ED] flex items-center justify-center mb-6">
              <Envelope size={28} weight="regular" className="text-[#7C8B6E]" />
            </div>
            <h1 className="font-editorial text-3xl tracking-tight text-[#1C1C1A]">
              Email inviata.
            </h1>
            <p className="mt-4 text-[#6B6A65] leading-relaxed">
              Se <strong className="text-[#1C1C1A]">{email}</strong> è registrata su Pronto, riceverai un link per reimpostare la password entro pochi minuti. Controlla anche la cartella spam.
            </p>
            <p className="mt-4 text-xs text-[#6B6A65]">
              Il link resta valido per 1 ora.
            </p>
            <Link to="/login" className="btn-outline mt-8 inline-flex" data-testid="back-to-login-sent">
              Torna al login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
